const readMore = document.querySelector(".readmore-container");
const readMoreButton = document.querySelector(".readmore-button");
const buttonText = readMoreButton.querySelector(".button-text");

readMoreButton.addEventListener("click", () => {
  // Toggle the active state on both the container and the button
  readMore.classList.toggle("active");
  readMoreButton.classList.toggle("active");

  // Update only the text, icons stay untouched
  if (readMore.classList.contains("active")) {
    buttonText.textContent = readMoreButton.dataset.readless;
  } else {
    buttonText.textContent = readMoreButton.dataset.readmore;
    if (!isInViewport(readMore)) {
      readMore.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  }
});

function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}